import dayjs from 'dayjs'
/**
 * @param {string} date - YYYY-MM-DD
 * @returns DDMMYY
 */
export const ConvertFormatDateToDDMMYY = (date: string) => {
    if (date != "") {
        return `${date.split('/')[2]}-${date.split('/')[1]}-${date.split('/')[0]}`
    }
    return date
}

export const YYYYMMDDToDDMMYY = (date: string) => {
    if (date != "") {
        return `${date.split('-')[2]}/${date.split('-')[1]}/${date.split('-')[0]}`
    }
    return date
}


export const TimeOut = async (ms: number) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export const CustomDateFormat = (date: string, format: string) => {
    if (date != "") {
        return dayjs(date).format(format)
    }
    return date
}
